export default "__VITE_ASSET__BGidFg7B__"